function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "library_add");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Two-Tone",
  transform: "translate(-782.000000, -952.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "AV",
  transform: "translate(100.000000, 852.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Two-Tone-/-AV-/-library_add",
  transform: "translate(680.000000, 98.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,16 L20,16 L20,4 L8,4 L8,16 Z M10,9 L13,9 L13,6 L15,6 L15,9 L18,9 L18,11 L15,11 L15,14 L13,14 L13,11 L10,11 L10,9 Z",
  id: "Secondary-Color",
  fill: "#D0D0D0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4,22 L18,22 L18,20 L4,20 L4,6 L2,6 L2,20 C2,21.1 2.9,22 4,22 Z M8,2 C6.9,2 6,2.9 6,4 L6,16 C6,17.1 6.9,18 8,18 L20,18 C21.1,18 22,17.1 22,16 L22,4 C22,2.9 21.1,2 20,2 L8,2 Z M20,16 L8,16 L8,4 L20,4 L20,16 Z M13,14 L15,14 L15,11 L18,11 L18,9 L15,9 L15,6 L13,6 L13,9 L10,9 L10,11 L13,11 L13,14 Z",
  id: "Primary-Color",
  fill: "#1D1D1D"
}))))));

var SvgLibraryAdd = function SvgLibraryAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLibraryAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/library_add.3bfa7050.svg";
export { ForwardRef as ReactComponent };